import { formatDateTime, longRelativeTime, relativeTime } from "@/utils/time"

export interface TimestampProps {
  seconds: number
  className?: string
  /** Absolute date instead of the relative short form. */
  absolute?: boolean
}

/** Timestamps are always `<time>` elements with a human readable tooltip. */
export function Timestamp({ seconds, className = "", absolute = false }: TimestampProps) {
  const label = absolute ? formatDateTime(seconds) : relativeTime(seconds)
  return (
    <time
      className={className}
      dateTime={new Date(seconds * 1000).toISOString()}
      title={formatDateTime(seconds)}
    >
      {label}
    </time>
  )
}

export function LongTimestamp({ seconds }: { seconds: number }) {
  return <span title={formatDateTime(seconds)}>{longRelativeTime(seconds)}</span>
}
